const translations = {
  "en": {
    "RSI": "RSI"
  },
  "zh-tw": {
    "RSI": "RSI"
  }
};

export default translations;
